<div>
    <div *ngFor="let item of items; let i = index">
        <app-logical-grouper
            [baseData]="item.baseData"
            [isSelectable]="item.selectionData.isSelectable"
            [isSelected]="item.selectionData.isSelected"
            [linkData]="item.linkData"
            [dropdownItems]="item.tasks"
            [isMandatory]="item.selectionData.isMandatory"
            [(items)]="item.selectedTasks"
            [readonly]="readonly"
            [grouperOnly]="grouperOnly"
            (delete)="onDelete(i)"
            (select)="onSelect(i)"
            (itemClicked)="onItemClicked($event)"
        ></app-logical-grouper>
        <br/>
    </div>

    <app-assignation-dropdown
        *ngIf="!readonly && !grouperOnly"
        class="create-dropdown"
        [items]="getDropdownItems()"
        (onSelect)="addItemToList($event)"
    >
    </app-assignation-dropdown>
</div>
